import { inject } from '@angular/core'
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { AuthService } from '../services/auth.service'
import { catchError, switchMap, throwError } from 'rxjs'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService)

  if (req.url.includes('https://www.googleapis.com/youtube/v3')) {
    return next(req)
  }

  const authToken = authService.getAuthToken()
  const userToken = authService.getToken()

  const authReq = req.clone({
    setHeaders: {
      'x-api-key': `${authToken}`,
      'authorization': `Bearer ${userToken}`
    }
  })

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.url.includes('/refresh')) {
        return authService.refreshToken().pipe(
          switchMap((newToken: string) => {
            authService.setAuthToken(newToken)
            const retryReq = req.clone({
              setHeaders: {
                'x-api-key': `${authToken}`,
                'authorization': `Bearer ${newToken}`
              }
            })
            return next(retryReq)
          }),
          catchError(err => {
            authService.logout()
            return throwError(() => err)
          })
        )
      }
      return throwError(() => error)
    })
  )
}
